import { render, staticRenderFns } from "./TrendyolChannelUpdateForm.vue?vue&type=template&id=47ad8e36&scoped=true"
import script from "./TrendyolChannelUpdateForm.vue?vue&type=script&lang=js"
export * from "./TrendyolChannelUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./TrendyolChannelUpdateForm.vue?vue&type=style&index=0&id=47ad8e36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ad8e36",
  null
  
)

export default component.exports